import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseResponse } from '@ibc-shared/model/base-response.model';
import { Observable, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PreRegistrationStatus } from '../models/preregistration-status.model';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserRepository {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/api/users`;

  public createUser(user: User): Observable<BaseResponse<User>> {
    return this.http.post<BaseResponse<User>>(`${this.baseUrl}/`, user).pipe(take(1));
  }

  public getUserById(id: string): Observable<BaseResponse<User>> {
    return this.http.get<BaseResponse<User>>(`${this.baseUrl}/${id}`).pipe(take(1));
  }

  public updateUser(id: string, user: Partial<User>): Observable<BaseResponse<User>> {
    return this.http.patch<BaseResponse<User>>(`${this.baseUrl}/${id}`, user).pipe(take(1));
  }

  public sendConfirmationAccountValidation(token: { token: string }): Observable<BaseResponse<string>> {
    return this.http.post<BaseResponse<string>>(`${this.baseUrl}/confirm`, token).pipe(take(1));
  }

  public getRegistration(userId: string | number): Observable<PreRegistrationStatus | null> {
    const url = `${this.baseUrl}/${encodeURIComponent(String(userId))}/product-requests`;
    return this.http.get<PreRegistrationStatus | null>(url, { withCredentials: true }).pipe(take(1));
  }
}
